export enum ModuleNames {
  Replenishment = 'Replenishment',
  Inventory = 'Inventory',
  StoreTransfer = 'StoreTransfer',
  Analytics = 'Analytics',
  Allocations = 'Allocations',
  SpecialEvents = 'SpecialEvents',
  PlanningAssistant = 'PlanningAssistant',
  DataCenter = 'DataCenter',
}
